import { render, staticRenderFns } from "./UserLeave.vue?vue&type=template&id=40f05e08&scoped=true"
import script from "./UserLeave.vue?vue&type=script&lang=js"
export * from "./UserLeave.vue?vue&type=script&lang=js"
import style0 from "./UserLeave.vue?vue&type=style&index=0&id=40f05e08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f05e08",
  null
  
)

export default component.exports